const message = {};

export default message;
